<template>
  <img
    :src="LoyaltyIconSvgLoyallist"
    alt="loyalty-bloom-top-of-the-list-small.svg"
  />
</template>

<script setup>
import LoyaltyIconSvgLoyallist from '@core/csg/src/assets/images/bcom/compressed/loyalty-bloom-top-of-the-list-small.svg';
</script>
